import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import styles from './modal.module.css';
import ModalOverlay from '../modal-overlay/modal-overlay';
import ModalHeader from '../modal-header/modal-header';

type ModalSize = 'SMALL' | 'LARGE' | 'LARGENS';

interface ModalProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  onClose: () => void;
  size?: ModalSize;
  showClose?: boolean; // 👈 добавили
}

const Modal: React.FC<ModalProps> = ({
  children,
  header,
  onClose,
  size = 'SMALL',
  showClose = true, // по умолчанию включён
}) => {
  const modalRoot = document.getElementById('react-modals');

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!modalRoot) return null;

  return ReactDOM.createPortal(
    <>
      <div className={styles.modal} role="dialog">
        {header && (
          <ModalHeader onClose={onClose} showClose={showClose}>
            {header}
          </ModalHeader>
        )}

        <div className={styles[`content${size}`]}>
          {children}
        </div>
      </div>

      <ModalOverlay onClose={onClose} />
    </>,
    modalRoot
  );
};

export default Modal;
